export const MEDIA_TYPE = {
  IMAGE: 0,
  VIDEO: 1,
};
